module.exports = __webpack_public_path__ + "img/period.01deb774.png";